module.exports = __webpack_public_path__ + "static/media/Cadence-bw.19fc2afa.png";